module.exports = __webpack_public_path__ + "static/item--entertainment-system@3x.07717d6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--entertainment-system@3x.png
// module id = 643
// module chunks = 126511778744290